function escapeHtml(value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

export function openExternalWithConfirm(vm, url, options = {}) {
  if (!url) {
    if (vm && vm.$message) {
      vm.$message.warning(options.emptyMessage || '暂无可打开链接')
    }
    return Promise.resolve(false)
  }

  let targetUrl
  try {
    targetUrl = new URL(url, window.location.origin)
  } catch (e) {
    if (vm && vm.$message) {
      vm.$message.error(options.invalidMessage || '链接地址格式不正确')
    }
    return Promise.resolve(false)
  }

  if (!['http:', 'https:'].includes(targetUrl.protocol)) {
    if (vm && vm.$message) {
      vm.$message.error(options.protocolMessage || '仅支持打开 http/https 链接')
    }
    return Promise.resolve(false)
  }

  const safeUrl = escapeHtml(targetUrl.href)
  const message = options.message || '您即将离开微思翻译，请注意您的账号和财产安全。'
  return vm.$confirm(
    `<div class="external-confirm-content"><span class="external-confirm-icon">!</span><div class="external-confirm-body"><p>${escapeHtml(message)}</p><p class="external-confirm-url">${safeUrl}</p></div></div>`,
    options.title || '即将离开微思翻译',
    {
      dangerouslyUseHTMLString: true,
      confirmButtonText: options.confirmText || '继续跳转',
      cancelButtonText: options.cancelText || '取消',
      type: 'warning',
      customClass: 'smart-external-confirm',
      confirmButtonClass: 'smart-external-confirm-btn'
    }
  ).then(() => {
    window.open(targetUrl.href, '_blank', 'noopener,noreferrer')
    return true
  }).catch(() => false)
}
